import React from 'react';
import ReactDom from 'react-dom';
import App from './app.js';
import 'antd/dist/antd.css';

ReactDom.render(<App />, document.getElementById('root'));